import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { CATEGORY_LABEL, COST_CATEGORIES, type CostCategory } from "../utils/categories";

type Props = {
  value: CostCategory | "";
  onChange: (next: CostCategory) => void;
  disabled?: boolean;
  id?: string;
  placeholder?: string;
  "aria-label"?: string;
  // Cuando se renderiza como filtro permitimos limpiar la selección.
  allowClear?: boolean;
};

const ALL_VALUE = "__all__";

export function CategorySelect({
  value,
  onChange,
  disabled,
  id,
  placeholder = "Categoría",
  "aria-label": ariaLabel,
  allowClear,
}: Props) {
  const selectValue = value === "" ? (allowClear ? ALL_VALUE : undefined) : value;

  return (
    <Select
      value={selectValue}
      onValueChange={(next) => {
        if (next === ALL_VALUE) {
          // Reabrimos como vacío externo; sólo aplica cuando allowClear.
          onChange("" as CostCategory);
        } else {
          onChange(next as CostCategory);
        }
      }}
      disabled={disabled}
    >
      <SelectTrigger id={id} className="h-10 w-full text-app-ink-1" aria-label={ariaLabel}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        {allowClear && <SelectItem value={ALL_VALUE}>Todas</SelectItem>}
        {COST_CATEGORIES.map((c) => (
          <SelectItem key={c} value={c}>
            {CATEGORY_LABEL[c]}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
